import { render, staticRenderFns } from "./TemplateDefaultSettings.vue?vue&type=template&id=24061948&"
import script from "./TemplateDefaultSettings.vue?vue&type=script&lang=js&"
export * from "./TemplateDefaultSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24061948')) {
      api.createRecord('24061948', component.options)
    } else {
      api.reload('24061948', component.options)
    }
    module.hot.accept("./TemplateDefaultSettings.vue?vue&type=template&id=24061948&", function () {
      api.rerender('24061948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/TemplateDefaultSettings.vue"
export default component.exports